module.exports = __webpack_public_path__ + "media/images/empty-state-add-list-items-1c1d3abcc95e6c74394ba9277980c140.svg";